var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoobiPayLogoDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 129,
    viewBox: "0 0 100 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.00011376 129V49.8258C-0.00011376 49.8258 -0.992805 8.63543 43.5322 0H99.9999V53.2739C99.9999 53.2739 96.7599 100.914 46.023 98.9028V71.2755L67.168 50.3089L77.1193 59.9287L77.3689 22.44L39.2021 22.2347L49.3422 32.2228L22.5212 58.5458V106.934L-0.00011376 129Z",
    fill: "#101018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2509 22.1501L49.3971 32.1383L22.5761 58.4612L31.0049 66.8189V103.969L46.0779 98.8183V71.1909L67.2229 50.2243L77.1742 59.8441L77.4239 22.3555L39.2509 22.1501Z",
    fill: "#DA5026"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 129,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoobiPayLogoDesktop);
export default __webpack_public_path__ + "static/media/MoobiPayLogo_desktop.c1854f7a4572ae4f490f542034a6bc03.svg";
export { ForwardRef as ReactComponent };